module.exports = __webpack_public_path__ + "img/cyber-defence-24.d509c00f.svg";